import { render, staticRenderFns } from "./FormatTranslatorTestTool.vue?vue&type=template&id=2cbb7034&scoped=true&"
import script from "./FormatTranslatorTestTool.vue?vue&type=script&lang=ts&"
export * from "./FormatTranslatorTestTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatTranslatorTestTool.vue?vue&type=style&index=0&id=2cbb7034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbb7034",
  null
  
)

export default component.exports